import axios from "axios";
import { services } from "configs/api";

const Branches = {
  get(repo, product) {
    return axios.get(
      services.productService(product, "ondemand", `branches/${repo}`)
    );
  },
};

export default Branches;
